module.exports = {
  background: '#FFFFFF',
  backgroundDark: '#EEE2DC',

  primary: '#AC3B61',
  primaryLight: '#db5c86',
  primaryDark: '#a8214e',

  secondary: '#EDC7B7',
  secondaryLight: '#ffd5c4',
  secondaryDark: '#ce8d73',
};
